module.exports = __webpack_public_path__ + "static/media/schoffaLogo.8c36abc9.svg";